<template>
    <div class="body-edit">
        <v-textarea
            ref="commentField"
            v-model="form_data.message"
            rows="1"
            auto-grow
            outlined
            dense
            class="pt-0"
            :hide-details="!form_data.message_error"
            :error-messages="form_data.message_error"
        ></v-textarea>
        <div class="mt-1 mb-1">
            <v-btn
                color="primary"
                class="inverted--text"
                :loading="form_data.message_loading"
                @click.stop="save_comment"
            >
                {{ $t("Save") }}
            </v-btn>
            <v-btn icon class="ml-2" @click.stop="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import AppModule from "../../store/modules/app";
import TaskModule from "../../store/modules/task";
import {getDescriptionWithoutLinks, getDescriptionWithLinks} from "@/helpers/formatting";

export default {
    name: "TaskEditCommentControl",
    props: {
        log: {
            type: Object,
            required: true
        },
        taskId: {
            type: [Number, String],
            required: true
        }
    },
    setup(props, ctx) {
        const appModule = AppModule();
        const { saveTaskComment } = TaskModule();

        const commentField = ref(null);
        const form_data = ref({
            message: getDescriptionWithoutLinks(props.log.message),
            message_error: null,
            message_loading: false
        });

        const save_comment = function() {
            form_data.value.message_loading = true;

            let data = {
                id: props.taskId,
                log_id: props.log.id,
                action: props.log.type,
                message: getDescriptionWithLinks(form_data.value.message)
            };

            saveTaskComment(data)
                .then(function() {
                    form_data.value.message_loading = false;
                    ctx.emit("close");
                })
                .catch(function(ex) {
                    appModule.handleErrorResponse(form_data.value, ex);
                    form_data.value.message_loading = false;
                });
        };

        setTimeout(function() {
            commentField.value.focus();
        }, 100);

        return {
            commentField,
            form_data,
            save_comment
        };
    }
};
</script>
